type MapMarketProps = {
	color?: string
	className?: string
	zIndex?: boolean
}

export const MapService = (props: MapMarketProps) => {
	const { color = `#0170C9`, className = `marker` } = props

	return (
		<svg
			className={className}
			width="43"
			height="53"
			viewBox="0 0 68 78"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g filter="url(#filter0_dd_25885_51181)">
				<path
					d="M58 31.375C58 52.2188 34 64 34 64C34 64 10 51.7656 10 31.375C10 17.3608 20.7452 6 34 6C47.2548 6 58 17.3608 58 31.375Z"
					fill={color}
				/>
			</g>
			<path
				d="M43.2322 36.701L43.2311 36.7L38.2297 32.5077C37.9977 32.313 37.6464 32.3235 37.427 32.5307L36.6025 33.3118L35.5802 32.3433L37.4019 30.2425C39.1034 31.0777 41.2484 30.8195 42.6765 29.4669C43.7976 28.4048 44.2065 26.9231 43.903 25.5554C43.8136 25.1517 43.2866 25.0029 42.9788 25.2949L41.06 27.1126C40.7116 27.4427 40.1468 27.4427 39.7983 27.1126C39.4263 26.7602 39.1422 26.4911 38.7702 26.1386C38.4218 25.8085 38.4218 25.2734 38.7702 24.9437L40.689 23.1256C40.9972 22.834 40.8401 22.3348 40.414 22.2501C38.9702 21.9625 37.4061 22.35 36.285 23.412C34.8573 24.765 34.5846 26.797 35.4663 28.4089L33.2487 30.1347L28.7266 25.8506L29.2274 25.3762C29.4333 25.1801 29.4121 24.8602 29.1854 24.6901L26.594 22.669C26.4006 22.524 26.1238 22.5392 25.9493 22.7046L24.5768 24.0048C24.4022 24.1702 24.3862 24.4324 24.5392 24.6155L26.673 27.0702C26.8561 27.2893 27.1951 27.3015 27.3969 27.1103L27.898 26.6356L32.3389 30.8427L24.5941 36.8699C23.8613 37.415 23.7965 38.4437 24.455 39.068C24.6347 39.2382 25.9707 40.5038 26.1504 40.674C26.8093 41.298 27.8953 41.2365 28.4707 40.5423L34.8328 33.2053L35.7739 34.0968L34.9174 34.9083C34.6975 35.1171 34.6879 35.4518 34.8956 35.6716L39.3608 40.3879C40.2435 41.3155 41.7589 41.3452 42.6823 40.4693L43.3289 39.8567C44.2598 38.9749 44.215 37.529 43.2322 36.701V36.701ZM27.3676 38.47C27.0436 38.47 26.7816 38.2213 26.7816 37.9149C26.7816 37.6081 27.0441 37.3598 27.3676 37.3598C27.6904 37.3598 27.9535 37.6072 27.9535 37.9149C27.9535 38.2213 27.6914 38.47 27.3676 38.47Z"
				fill="white"
			/>
			<defs>
				<filter
					id="filter0_dd_25885_51181"
					x="0"
					y="0"
					width="68"
					height="78"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="5" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25885_51181" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="4" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.05 0" />
					<feBlend mode="normal" in2="effect1_dropShadow_25885_51181" result="effect2_dropShadow_25885_51181" />
					<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_25885_51181" result="shape" />
				</filter>
			</defs>
		</svg>
	)
}
